<template>
  <!-- 公司详情 -->
  <div>
    <QS-h3-title>
      <template slot="title"
        >批量付款详情</template
      >
    </QS-h3-title>
    <div class="splitline mt16 mb16" />
    <QS-h4-title title="批量付款信息" />
    <CollectionRecordDetailsForm
      :source="source"
      :enterScene="3"
      scenetype="payment"
    />
    <QS-h4-title title="付款详情" />
    <CollectionRecordDetailsTable :id="id" scenetype="payment" />
  </div>
</template>

<script>
import CollectionRecordDetailsForm from '@/components/CollectionRecordDetails/CollectionRecordDetailsForm'
import CollectionRecordDetailsTable from '@/components/CollectionRecordDetails/CollectionRecordDetailsTable'

import { getbatchPaymentRecordDetails } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'


export default {
  name: 'cpInfoDetail',
  components: {
    CollectionRecordDetailsForm,
    CollectionRecordDetailsTable,
  },
  data() {
    return {
      source: {},
    }
  },
  computed: {
    id() {
      return this.$route.query?.id
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  methods: {
    async getDetail(id) {
      const { data } = await getbatchPaymentRecordDetails({ id })
      this.source = {
        ...data,
        customerType: selectOption.customerTypeDict[data.customerType] || null,
        state: selectOption.collectionStateList[data.state],
        amount: this.numberWithCommas(data.amount), // 付款金额
        attachment: data.attachment,
      }
    },
  },
  mounted() {
    const { id } = this.$route.query
    if (id) {
      this.getDetail(id)
    } else {
      this.$message.error('缺少参数')
      this.$router.back()
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}

img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .qs-h4-container-left {
  font-size: 16px;
}

.company_photos {
  ::v-deep .el-form-item__label {
    min-width: 162px;
  }

  .images-list {
    font-size: 0;
    width: 500px;
    height: 200px;
    flex-wrap: wrap;

    img {
      width: 80px;
      height: 80px;
      margin-left: 12px;

      &:nth-child(1),
      &:nth-of-type(6) {
        margin-left: 0;
      }

      &:nth-of-type(n + 6) {
        margin-top: 16px;
      }
    }
  }
}
</style>
